/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

const EXAMPLES = {
  "south-comparative-regions-south-comparative-01-what-the-tradition-means-kp-1": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-01-what-the-tradition-means-kp-2": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-01-what-the-tradition-means-kp-3": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-01-what-the-tradition-means-kp-4": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-01-what-the-tradition-means-kp-5": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-02-shared-instruments-kp-1": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-02-shared-instruments-kp-2": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-02-shared-instruments-kp-3": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-02-shared-instruments-kp-4": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-02-shared-instruments-kp-5": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-03-forms-compared-kp-1": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-03-forms-compared-kp-2": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-03-forms-compared-kp-3": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-03-forms-compared-kp-4": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-03-forms-compared-kp-5": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-04-revivals-compared-kp-1": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-04-revivals-compared-kp-2": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-04-revivals-compared-kp-3": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-04-revivals-compared-kp-4": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "south-comparative-regions-south-comparative-04-revivals-compared-kp-5": {
    "kind": "none",
    "illustrationPlan": "South-Comparative trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  }
}

export default EXAMPLES
